import { ImagesSkusChevronDownSvg } from '@/assets/images_skus.assets';
import DefaultButton from '@/components/common/default/DefaultButton';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { SkusEnum } from '@/types/translations/SkusEnum';
import { Checkbox, Field, Label, Transition } from '@headlessui/react';
import Image from '@/components/common/SpiritoryImage';
import { Fragment, useState } from 'react';
import { FaCheck } from 'react-icons/fa';
import { useToggleRefinement } from 'react-instantsearch';
import { CommonEnum } from '@/types/translations/CommonEnum';

export default function SkusMobileSearchShowStatusFilter() {
  const { translate } = useTypedTranslation<SkusEnum>('skus');
  const { translate: translateCommon } = useTypedTranslation<CommonEnum>('common');

  const [showStatusItems, setShowStatusItems] = useState(false);

  const toggleHasBidRefinement = useToggleRefinement({
    attribute: 'hasBid',
  });

  const toggleHasAskRefinement = useToggleRefinement({
    attribute: 'hasAsk',
  });

  return (
    <li>
      {' '}
      <DefaultButton
        className="tw-flex tw-w-full tw-items-center tw-justify-between tw-font-plusJakartaSans !tw-text-base tw-font-semibold tw-text-textBlack"
        onClick={() => setShowStatusItems(prev => !prev)}
      >
        <span>{translate(SkusEnum['status'])}</span>
        <Image src={ImagesSkusChevronDownSvg} width={5.59} height={12} alt="Chevron Down" />
      </DefaultButton>
      <Transition
        as={Fragment}
        show={showStatusItems}
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-300"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <ul className="tw-mt-4 tw-flex tw-flex-col tw-gap-4 tw-border tw-border-l-0 tw-border-r-0 tw-border-t-0 !tw-border-solid tw-border-custom-gray tw-p-0 tw-pb-4">
          <Field className="tw-flex tw-items-center tw-gap-2" as="li">
            <Checkbox
              name="checkbox-hasBid"
              id="checkbox-hasBid"
              checked={toggleHasBidRefinement.value.isRefined}
              onChange={() => {
                const newValue = toggleHasBidRefinement.value.isRefined;
                toggleHasBidRefinement.refine({ isRefined: newValue });
              }}
              disabled={!toggleHasBidRefinement.canRefine}
              className="tw-group tw-flex tw-size-6 tw-items-center tw-justify-center tw-rounded-md tw-border-2 !tw-border-solid tw-border-custom-gray tw-bg-white data-[checked]:tw-bg-main"
            >
              <FaCheck className="tw-text-xs tw-text-transparent group-data-[checked]:tw-text-white" />
            </Checkbox>
            <Label
              className="tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-text-text"
              htmlFor={`checkbox-hasBid`}
            >
              {translateCommon(CommonEnum['has_bids'])}{' '}
              <span className="tw-rounded-full tw-bg-baby-blue tw-px-3 tw-py-1 tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-text-textBlack">
                {toggleHasBidRefinement.value.count}
              </span>
            </Label>
          </Field>
          <Field className="tw-flex tw-items-center tw-gap-2" as="li">
            <Checkbox
              id="checkbox-hasAsk"
              name="checkbox-hasAsk"
              checked={toggleHasAskRefinement.value.isRefined}
              onChange={() => {
                const newValue = toggleHasAskRefinement.value.isRefined;
                toggleHasAskRefinement.refine({ isRefined: newValue });
              }}
              disabled={!toggleHasAskRefinement.canRefine}
              className="tw-group tw-flex tw-size-6 tw-items-center tw-justify-center tw-rounded-md tw-border-2 !tw-border-solid tw-border-custom-gray tw-bg-white data-[checked]:tw-bg-main"
            >
              <FaCheck className="tw-text-xs tw-text-transparent group-data-[checked]:tw-text-white" />
            </Checkbox>
            <Label
              className="tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-text-text"
              htmlFor={`checkbox-hasAsk`}
            >
              {translateCommon(CommonEnum['has_asks'])}{' '}
              <span className="tw-rounded-full tw-bg-baby-blue tw-px-3 tw-py-1 tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-text-textBlack">
                {toggleHasAskRefinement.value.count}
              </span>
            </Label>
          </Field>
        </ul>
      </Transition>
    </li>
  );
}
